import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=31563dd1&scoped=true"
import script from "./sitemap.vue?vue&type=script&lang=js"
export * from "./sitemap.vue?vue&type=script&lang=js"
import style0 from "./sitemap.vue?vue&type=style&index=0&id=31563dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31563dd1",
  null
  
)

export default component.exports